import React, { PureComponent, PropTypes } from 'react';
import { browserHistory } from 'react-router';
import DropdownMenu from 'ak-dropdown-menu';

import { BASE_URL } from '../../config';

export default class ComponentDetailVersionDropdown extends PureComponent {
  static propTypes = {
    defaultSelectedVersion: PropTypes.string,
    allVersions: PropTypes.array,
  }

  static defaultProps = {
    allVersions: [],
  }

  state = {
    selectedVersion: null,
  }

  componentDidUpdate() {
    const { defaultSelectedVersion } = this.props;

    if (!this.state.selectedVersion && defaultSelectedVersion) {
      this.setState({
        selectedVersion: defaultSelectedVersion,
      });
    }
  }

  selectVersion = (attrs) => {
    browserHistory.push(attrs.item.value);
    this.setState({
      selectedVersion: attrs.item.content
    });
  };

  render() {
    const { allVersions, componentName } = this.props;
    if (!allVersions.length) return null;

    const dropItems = [{
      heading: '',
      items: allVersions.map(version => ({
        value: `${BASE_URL}/${componentName}/${version}/index.html`,
        content: version,
      })),
    }];

    return (
      <div style={{ display: 'inline-block', fontSize: '14px' }}>
        <DropdownMenu
          items={dropItems}
          triggerType='button'
          onItemActivated={this.selectVersion}
        >
          {this.state.selectedVersion}
        </DropdownMenu>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/ComponentDetailPage/ComponentDetailVersionDropdown.jsx